import { ReactNode } from 'react';
import { PINNED_RIGHT_EDGE_LINE_STYLE } from '../../../../../../../../constants/borderStyles';
export type ActionColumnCellProps = {
  width: number;
  heightPx: number;
  children: ReactNode;
};

/**
 * Sticky <td> cell for the action column.
 * Owns all layout concerns: sticky positioning, drop shadow, edge line, width constraints,
 * and stopPropagation to prevent row click when interacting with action buttons.
 */
export function ActionColumnCell(props: ActionColumnCellProps) {
  const handleClick = (event: React.MouseEvent) => {
    // Prevent row click from firing when interacting with action buttons
    event.stopPropagation();
  };
  return <td className="p-0 border-0 bg-white shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.15)]" style={{
    position: 'sticky',
    right: 0,
    zIndex: 'var(--z-sidebar)',
    width: props.width,
    maxWidth: props.width,
    height: props.heightPx,
    maxHeight: props.heightPx
  }} onClick={handleClick}>
      <span style={PINNED_RIGHT_EDGE_LINE_STYLE} />
      {props.children}
    </td>;
}